import React, { useContext, useEffect, useState } from 'react';
import { ReactComponent as CloseForm } from '../images/close-message.svg';
import './ConfirmationModal.css';
import { AppInfoContext } from '../../../../App';

function ConfirmationModal() {
  const { setAppInformation } = useContext(AppInfoContext);

  const nextStep = () => {
    setAppInformation((prevValue) => {
      const { citizenReport } = prevValue;
      return {
        ...prevValue,
        citizenReport: {
          ...citizenReport,
          currentStep: prevValue.citizenReport.currentStep + 1,
        },
      };
    });
  };

  const previousStep = () => {
    setAppInformation((prevValue) => {
      const { citizenReport } = prevValue;
      return {
        ...prevValue,
        citizenReport: {
          ...citizenReport,
          issueCoordinates: { x: null, y: null },
        },
      };
    });
  };

  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {visible && (
        <div className="confirmation-modal">
          <div className="cm-bg-shadow " onClick={previousStep}></div>
          <div className="cm-message-container">
            <div className="cm-form-header">
              <div className="cm-form-header-title">Prijava kvara</div>
              <button
                style={{ fontWeight: 'bolder' }}
                className="cm-form-close-button"
                onClick={previousStep}
              >
                <CloseForm style={{ height: '10px' }} />
              </button>
            </div>

            <div className="cm-message-body">
              <div className="cm-message-text">
                Lokacija označena. Ukoliko želite promijeniti lokaciju kliknite
                na dugme nazad.
              </div>

              <div className="cm-buttons">
                <button
                  className="cm-message-close-button"
                  onClick={previousStep}
                >
                  Nazad
                </button>
                <button className="cm-message-close-button" onClick={nextStep}>
                  Dalje
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ConfirmationModal;
